import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Users } from 'server/shared/collections/users';
import { RoleEnum } from 'server/shared/models/role.enum';
import { User } from 'server/shared/models/user';

@Component({
  selector: 'app-user-select',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: UserSelectComponent,
      multi: true,
    },
  ],
})
export class UserSelectComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  users: User[] = [];

  private destroyed$ = new Subject<void>();

  selectedUser?: User;
  @Input() disabled = false;
  userIdNotActive: boolean = false;

  @Input() label?: string;
  @Input() filterRole?: RoleEnum;
  @Input() fallBackInfo?: {
    userId?: string;
    firstName?: string;
    lastName?: string;
  };

  onChange: any = (selectedUser: User) => {};
  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  onTouch: any = () => {};
  registerOnTouched(onTouched: Function) {
    this.onTouch = onTouched;
  }
  constructor() {}

  ngOnInit(): void {
    const query: any = { isIntemp: { $ne: true } };
    if (this.filterRole) {
      query.role = this.filterRole;
    }
    Users.find(query)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((users) => {
        this.users = users;
        if (
          this.fallBackInfo?.userId &&
          !this.users?.some((user) => user._id === this.fallBackInfo?.userId)
        ) {
          this.userIdNotActive = true;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  emitChange() {
    this.onChange(this.selectedUser);
  }

  writeValue(value: any) {
    this.selectedUser = value;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
}
